import BaseAction from './BaseAction';

class SkipToAction extends BaseAction {
    constructor(data) {
        super(data);
        this.timeIndex = data.timeIndex;
    }
}

export default SkipToAction;